import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { colors, fontSize, size } from "@styles/theme";
import {
  PiArrowLeftBold,
  PiArrowRightBold,
  PiCaretLeftBold,
} from "react-icons/pi";
import { useNavigate } from "react-router-dom";

const NextStepsContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const BottomArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

const CapsuleArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: ${size(1)};
`;

const Capsule = styled.div`
  padding: ${size(1)};
  border-radius: 100px;
  background-color: black;
  font-size: ${fontSize("sm")};
  margin-top: ${size(0.5)};
`;

const ButtonArea = styled.div`
  display: flex;
  flex-direction: column;
  // align-items: center;
  width: 100%;
`;

const RegisterModalNextSteps = ({ setClosed, setClosedAndNavigateTo }) => {
  const navigate = useNavigate();

  return (
    <NextStepsContainer>
      {/* <h1 style={{ textAlign: 'center', lineHeight: size(5), fontSize: size(3), margin: `0 ${size(1)}` }}>🥳 🎉 😏<br />Welcome Aboard!</h1> */}
      <h1
        style={{
          textAlign: "center",
          lineHeight: size(5),
          fontSize: size(3),
          margin: `0 ${size(1)}`,
        }}
      >
        🎆 🥂 🚢
        <br />
        Welcome Aboard!
      </h1>
      <p
        style={{
          textAlign: "center",
          fontSize: fontSize("sm"),
          lineHeight: size(2.5),
          margin: `${size(1)}`,
        }}
      >
        🐣 Mandrake is a new application
        <br />
        <br />
        {/* <div style={{ height: size(1) }} /> */}
        Our plans for <b>Supporters</b> include:{" "}
        <em>Travel Mode, Hidden Mode, and Priority Map Placement</em>
      </p>
      <BottomArea>
        <CapsuleArea>
          <Capsule
            style={{
              backgroundColor: colors.statusColors.browsing("lightRgba")(0.5),
              border: `0.5px solid ${colors.statusColors.browsing("primary")}`,
              fontWeight: "600",
            }}
          >
            $3.99/mo
          </Capsule>
          &nbsp;
          <Capsule
            style={{
              backgroundColor: colors.statusColors.right_now("lightRgba")(0.5),
              border: `0.5px solid ${colors.statusColors.right_now("primary")}`,
              fontWeight: "600",
            }}
          >
            $19.99/6m
          </Capsule>
          &nbsp;
          <Capsule
            style={{
              backgroundColor: colors.statusColors.chatting("lightRgba")(0.5),
              border: `0.5px solid ${colors.statusColors.chatting("primary")}`,
              fontWeight: "600",
            }}
          >
            $35/1y
          </Capsule>
        </CapsuleArea>
        <ButtonArea>
          <Button
            variant="contained"
            style={{
              borderRadius: "100px",
              padding: size(1.5),
              marginBottom: size(1),
              background:
                "linear-gradient(172.5deg, #2293EE 23.12%, #751DE4 110%)",
            }}
            onClick={() => setClosedAndNavigateTo("/subscription")}
          >
            See Supporter Plans&nbsp;
            <PiArrowRightBold />
          </Button>
          <Button
            variant="outlined"
            style={{
              borderRadius: "100px",
              padding: size(1.5),
              border: "1px solid grey",
              color: "white",
            }}
            onClick={() => (setClosed ? setClosed() : navigate(-1))}
          >
            <PiArrowLeftBold />
            &nbsp; Exit
          </Button>
        </ButtonArea>
      </BottomArea>
    </NextStepsContainer>
  );
};

export default RegisterModalNextSteps;
